// extracted by mini-css-extract-plugin
export default {"component":"oalhW","tooltip":"jept9"};